const ActionByChip = ({ actionByName, className }) => {
  return (
    <span
      className={`${
        className
          ? className
          : "text-capitalize outlined-chip basic d-inline-block mt-2 ms-2 mb-2"
      }`}
    >
      Action By: {actionByName}
    </span>
  );
};

export default ActionByChip;
